module.exports = __webpack_public_path__ + "static/hacibaba-web-7a5a3faa3be66343316df2fff1eed3a1.jpg";